import { useMemo, useState } from 'react';

export function useTabs<T = any>(children: Array<T>, initialTabIndex = 0): [number, Array<() => void>] {
  const [selectedTab, setSelectedTab] = useState(initialTabIndex);
  const handlers = useMemo(() => children.map((_, i) => () => setSelectedTab(i)), [children.length]);
  return [selectedTab, handlers];
}
